import { Component, OnInit } from "@angular/core";
import { LangChangeEvent, TranslateService } from "@ngx-translate/core";

import { IWService } from "../../../core/services/iw.service";

@Component({
  selector: "app-idiom",
  templateUrl: "./idiom.component.html",
  styleUrls: ["./idiom.component.scss"],
})
export class IdiomComponent implements OnInit {
  currentLanguage: string;
  constructor(public translate: TranslateService,
    private iwService: IWService) {
    translate.addLangs(["en", "es"]);
  }

  ngOnInit(): void {
    let localLang = localStorage.getItem("language");
    if(localLang == null)
    {
      localLang = "es";
    }
    this.currentLanguage = localLang;
    
  }

  async switchLang(lang: string) {
    if (lang) {
      this.translate.use(lang);
      localStorage.setItem("language", lang);
      this.currentLanguage = lang;
      await this.iwService.handshake(lang);
    }
  }
}
